<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">top ups</h4>
                        </div>
                        <div class="row" v-if="permissions.includes('filter-recharge')" >
                            From : <input class="form-control col-lg-4" @change="first" type="date" v-model="payload.from" name="" id="">
                            To : <input class="form-control col-lg-4" @change="second" type="date" v-model="payload.to" name="" id="">
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="d-flex justify-content-end mb-3">
                        <input v-model="tableSearch" type="search" class="form-control" style="max-width: 360px;" placeholder="Search top ups" aria-label="Search top ups">
                    </div>
                    <div class="table-responsive rounded mb-3" v-if="label.length==0">
                        <table id="example" class="data-table table mb-0 tbl-server-info" >
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>#</th>
                                    <th>Beneficiary</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Credit By</th>
                                    <th v-if="permissions.includes('delete-recharge')">Action</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(recharge,index) in filteredRecharges" :key="index">
                                    <td v-if="recharge.user != null">{{ index +1}}</td>
                                    <td v-if="recharge.user != null">{{ recharge.user.nom +' '+recharge.user.prenoms }}</td> 
                                    <td v-if="recharge.user != null">{{formatPrice(recharge.montant)  }} XOF</td>  
                                    <td v-if="recharge.pack != null && recharge.user != null"> Intern </td>   
                                    <td v-if="recharge.pack == null && recharge.user != null"> Extern </td>
                                    <td v-if="recharge.user != null">{{ recharge.created_at }}</td> 
                                    <td v-if="recharge.created_by != null">{{ recharge.created_by.nom +' '+recharge.created_by.prenoms }}</td>
                                    <td v-if="permissions.includes('delete-recharge')">
                                        <div class="d-flex align-items-center list-action">
                                            <button v  class="badge badge-info bg-warning mr-2 btn" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                                @click="destroy(recharge.id)"><i class="fa fa-trash mr-0"></i>
                                            </button>
                                        </div>
                                    </td> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive rounded mb-3" v-else>
                        <table id="example"  class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Label</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body" v-if="label.length>0">
                                <tr v-for="(bail,index) in filteredLabels" :key="index">
                                    <td>{{bail}}</td>
                                    <td>{{formatPrice(value[index])}} XOF</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                
            </div>
        </div>
            <!-- Page end  -->
        </div>
        <!-- Modal Edit -->
        <div class="vld-parent">
                <loading v-model:active="isLoading"
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            </div>
    </div>
</template>
<script>
import axios from "axios";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/css/index.css';
import Swal from 'sweetalert2'
import moment from 'moment'
moment.locale('fr')

export default {
    components: {
            Loading
    },
    data() {
        return {
            permissions: [],
            recharges:[],
            tableSearch: '',
            isLoading: false,
            fullPage: true,
            payload:{
                from:'',
                to:''
            },
            recap:null,
            cout:0,
            label:[],
            value:[],
        };
    },
    mounted(){this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getPacks()
    },
    computed: {
        filteredRecharges() {
            const search = this.tableSearch.trim().toLowerCase()
            return search ? this.recharges.filter(recharge => [recharge.user && recharge.user.nom, recharge.user && recharge.user.prenoms, recharge.montant, recharge.created_at, recharge.created_by && recharge.created_by.nom, recharge.created_by && recharge.created_by.prenoms].some(value => String(value || '').toLowerCase().includes(search))) : this.recharges
        },
        filteredLabels() {
            const search = this.tableSearch.trim().toLowerCase()
            return search ? this.label.filter(value => String(value || '').toLowerCase().includes(search)) : this.label
        },
    },
    methods:{
        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getPacks(){
            let app = this
            app.isLoading = true
            axios.get('recharge')
            .then(function (reponse){
                console.log(reponse);
                if (reponse.data.status == true) {
                    app.recharges = reponse.data.data
                    app.recharges.forEach(element => {
                        element.created_at = moment(element.created_at).format('DD-MM-YYYY H:m')
                    });
                }
                
            })
            .catch(function (error){
                console.log(error);
            })
            app.isLoading = false
        },
        first() {
            if (this.payload.from != '') {
                if (this.payload.to != '') {
                    this.getRechargeRecap()
                } else {
                    Swal.fire('Note', 'Enter end date.', 'info')
                }
            } else {
                Swal.fire('Note', 'Enter begin date.', 'info')
            }
        },
        second() {
            if (this.payload.to != '') {
                if (this.payload.from != '') {
                    this.getRechargeRecap()
                } else {
                    Swal.fire('Note', 'Enter begin date.', 'info')
                }
            } else {
                Swal.fire('Note', 'Enter end date.', 'info')
            }
        },
        getRechargeRecap() {
            this.isLoading =  true
            axios.post('rechargeRecap', this.payload)
            .then(reponse => {
                console.log('recap', reponse)
                if (reponse.data.status == true) {
                    this.label = Object.keys(reponse.data.data)
                    this.value = Object.values(reponse.data.data)

                    console.log(this.label,this.value)
                    if (this.value.length == 0) {
                        Swal.fire('Note', 'No ticket printed in this period!', 'info')
                    }
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                
            })
            this.isLoading = false
        },
        destroy(id) {
            Swal.fire({
                title: 'Do you want to delete this credit ?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, deleted!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete('recharge/'+id)
                    .then(response => {
                        console.log(response.data)
                        this.isLoading =  false
                        Swal.fire(
                            'Deleted!',
                            'The credit was deleted.',
                            'success'
                        )
                        location.reload()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                    
                }
            })
            
        },
    }
}
</script>